module.exports = __webpack_public_path__ + "img/DE02243.07dfe404.png";